import HeaderTitle from '../../Molecules/HeaderTitle/HeaderTitle'
import FormCategory from "../../Organisms/FormCategory/FormCategory";
const CreateCategory = () => {
  return (
    <>
    <div className="nd-grid">
      <HeaderTitle headerText="Crear categorías" withDivider />
      <div className="box s-pxy-20 m-pxy-50">
        <FormCategory />
      </div>
    </div>
    </>
  )
}

export default CreateCategory
